// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2988":"8edd2ab58426e32cc0af","3480":"4f635441fd8ba273bdb1","3904":"d6d16c052c9e99cbcff0","8682":"4cec7ed75e7998c8ad25"}[chunkId] + ".css";
};